import { getClassNames } from '@websolutespa/bom-core';
import { motion } from 'framer-motion';
import { ActionsProvider } from '../../../useLlm/useActions';
import { useLlm } from '../../../useLlm/useLlm';
import { Portals } from '../Portals/portals';
import style from './page-main.module.scss';

export const PageMain: React.FC = () => {
  const {
    PageIntro,
    PageThread,
    PagePrompt,
  } = useLlm(state => state.components);
  const message = useLlm(state => state.message);
  const streaming = useLlm(state => state.streaming);

  const reveal = {
    hidden: {
      opacity: 0,
      scale: .98,
    },
    show: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: .3,
      },
    },
    exit: {
      opacity: 0,
      transition: {
        duration: .3,
        delay: .3,
      },
    },
  };

  const classNames = getClassNames(style.main);

  return (
    <motion.div
      key="page-main-container"
      className={classNames}
      variants={reveal}
      initial="hidden"
      animate="show"
      exit="exit"
      data-lenis-prevent
    >
      <ActionsProvider>
        <Portals>
          {(streaming || message) ? (
            <PageThread />
          ) : (
            <PageIntro />
          )}
        </Portals>
        {(streaming || message) ? (
          <PagePrompt />
        ) : (
          <></>
        )}
      </ActionsProvider>
    </motion.div>
  );
};

